import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showModal(event) {
    const imageUrl = event.currentTarget.dataset.documentCarouselUrlValue
    const modal = document.getElementById('imageModal')
    const modalImage = document.getElementById('modalImage')
    
    modalImage.src = imageUrl
    
    const bootstrapModal = new bootstrap.Modal(modal)
    bootstrapModal.show()
  }
}
